<script setup lang="ts">
import { useFormKitContextById } from "@formkit/vue";
import { useRouteParams } from "@vueuse/router";
import type { CreateInboundProductRequestV2 } from "mws-catalog-ts-sdk";
import type { Ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import BaseButton from "@/common/components/BaseButton.vue";
import { useCreateInboundProductMutation } from "@/inbound/api/queries";
import InboundProductForm from "@/inbound/components/InboundProductForm.vue";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";

definePage({
  meta: {
    layout: AnonymousLayout,
  },
});

const inboundProductCreateForm = useFormKitContextById(
  "inboundProductCreateForm",
);

const router = useRouter();
const { t } = useI18n();

const reportId = useRouteParams("reportId") as Ref<string>;
const { mutateAsync: createInboundProduct } = useCreateInboundProductMutation();
const submitForm = () => {
  const node = inboundProductCreateForm.value?.node;
  node?.submit();
};

const onSubmit = async (request: CreateInboundProductRequestV2) => {
  await createInboundProduct({
    reportId: reportId.value,
    createInboundProductRequestV2: request,
  });
  router.go(-1);
};

const onCancel = () => {
  router.go(-1);
};
</script>

<template>
  <div>
    <div class="bg-gray-100 pb-3">
      <div class="p-3 bg-white">
        <p class="font-bold text-lg py-1">
          {{ t("inboundReport.productCreate.title") }}
        </p>
        <p>{{ t("inboundReport.productCreate.info") }}</p>
      </div>
    </div>

    <div class="bg-white">
      <InboundProductForm
        id="inboundProductCreateForm"
        mode="Create"
        type="form"
        :actions="false"
        form-class="pb-28"
        messages-class="mx-3"
        @submit="onSubmit"
      />
    </div>

    <div class="flex flex-col gap-1 fixed bottom-0 bg-white w-full p-3">
      <BaseButton
        variant="primary"
        :label="t('inboundReport.productCreate.addButton')"
        @click="submitForm"
      />
      <BaseButton
        variant="secondary"
        :label="t('inboundReport.productCreate.cancelButton')"
        @click="onCancel"
      />
    </div>
  </div>
</template>
